class ContestForm extends BaseForm {

	constructor(options) {

		super(options);

		//set default variables
		this.fields = [
			{name: 'first_name', pattern: /^.{2,}$/i},
			{name: 'last_name', pattern: /^.{2,}$/i},
			{name: 'email', type: 'email'},
			{name: 'postal_code', type: 'zipcode'},
		];

		this.$('.to-validate').each((index,value) => {
			let field = $(value);

			let obj = {name: field.attr('name')};

			if(field.attr('data-type'))
				obj.type=field.attr('data-type');

			if(field.attr('data-pattern'))
				obj.pattern=field.attr('data-pattern');

			this.fields.push(obj);
		});

		this.$('.datepicker').datetimepicker({
			format: 'L'
		});
	}
}